const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const centrosCostoService = {
  // Obtener todos los centros de costo
  async getAll() {
    try {
      const response = await fetch(`${API_URL}/centros-costo`);
      if (!response.ok) {
        throw new Error('Error al obtener los centros de costo');
      }
      return await response.json();
    } catch (error) {
      console.error('Error al obtener los centros de costo:', error);
      throw error;
    }
  },

  // Obtener centros de costo con filtros y paginación
  async getWithFilter({ limit, offset, query }) {
    try {
      const response = await fetch(`${API_URL}/centros-costo/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ limit, offset, query }),
      });

      if (!response.ok) {
        throw new Error('Error al obtener los centros de costo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener los centros de costo:', error);
      throw error;
    }
  },

  // Obtener centro de costo por ID
  async getById(id) {
    try {
      const response = await fetch(`${API_URL}/centros-costo/${id}`);
      if (!response.ok) {
        throw new Error('Error al obtener el centro de costo');
      }
      return await response.json();
    } catch (error) {
      console.error('Error al obtener el centro de costo:', error);
      throw error;
    }
  },

  // Crear nuevo centro de costo
  async create(centroCostoData) {
    try {
      const response = await fetch(`${API_URL}/centros-costo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(centroCostoData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al crear el centro de costo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error al crear el centro de costo:', error);
      throw error;
    }
  },

  // Actualizar centro de costo
  async update(id, centroCostoData) {
    try {
      const response = await fetch(`${API_URL}/centros-costo/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(centroCostoData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al actualizar el centro de costo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error al actualizar el centro de costo:', error);
      throw error;
    }
  },

  // Eliminar centro de costo
  async delete(id) {
    try {
      const response = await fetch(`${API_URL}/centros-costo/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al eliminar el centro de costo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error al eliminar el centro de costo:', error);
      throw error;
    }
  },

  // Exportar centros de costo
  async export(query = {}) {
    try {
      const response = await fetch(`${API_URL}/centros-costo/export`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(query),
      });

      if (!response.ok) {
        throw new Error('Error al exportar los centros de costo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error al exportar los centros de costo:', error);
      throw error;
    }
  },
};
